import { render, staticRenderFns } from "./TTLoyalitySettings.vue?vue&type=template&id=251400af"
import script from "./TTLoyalitySettings.vue?vue&type=script&lang=js"
export * from "./TTLoyalitySettings.vue?vue&type=script&lang=js"
import style0 from "./TTLoyalitySettings.vue?vue&type=style&index=0&id=251400af&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports